'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
var n=/(\s*[\w\u4e00-\u9fa5]+\s*:)|(:\s*\'.*?\')|(\'.*?\'\s*:)/gm;function g(s){let e;for(;(e=n.exec(s))!==null;){e.index===n.lastIndex&&n.lastIndex++;let t=e[0].trim(),i=e[0].length,a=t.endsWith(":");t.startsWith(":")&&(t=t.substring(1)),t.endsWith(":")&&(t=t.substring(0,t.length-1)),t.startsWith("'")&&t.endsWith("'")&&(t=t.substring(1,t.length-1)),t='"'+t+'"';let h=a?t+": ":" :"+t;s=`${s.substring(0,e.index)}${h}${s.substring(e.index+i)}`;}return JSON.parse(s)}

exports.a = g;
